import traverse from "traverse";
import { kebabCase } from "lodash/fp";
export default function themeToCssCustomProps(theme) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$defaultName = _ref.defaultName,
    defaultName = _ref$defaultName === void 0 ? "default" : _ref$defaultName;
  var props = {};
  traverse(theme).forEach(function (value) {
    if (this.isLeaf && (typeof value === "string" || typeof value === "number") && value !== "") {
      var prop = "--".concat(this.path.filter(function (name) {
        return name !== defaultName;
      }).map(kebabCase).join("-"));
      props[prop] = value;
    }
  });
  return props;
}